import { MrfiktivHttpClientProvider } from "@/services/mrfiktiv/mrfiktiv-http-client.provider";
import {
  MrfiktivLeadResponseControllerGetParamsGen,
  MrfiktivLeadResponseControllerRespondParamsGen,
  MrfiktivLeadResponseDtoGen
} from "../v1/data-contracts";
import { LeadResponse } from "../v1/LeadResponse";

/**
 * Communicate with lead API
 */
class LeadResponseService {
  mrfiktivProxy: LeadResponse;

  /**
   * Construct service
   */
  constructor(mrfiktivHttpClientProvider: MrfiktivHttpClientProvider) {
    this.mrfiktivProxy = new LeadResponse(mrfiktivHttpClientProvider.client());
  }

  /**
   * Create a lead
   */
  async getDocumentBySharedAccessToken(data: MrfiktivLeadResponseControllerGetParamsGen) {
    const lead = (await this.mrfiktivProxy.leadResponseControllerGet(data)).data;

    return lead;
  }

  /**
   * Get all leads
   */
  async respond(query: MrfiktivLeadResponseControllerRespondParamsGen, data: MrfiktivLeadResponseDtoGen) {
    const leads = (await this.mrfiktivProxy.leadResponseControllerRespond(query, data)).data;

    return leads;
  }
}

/**
 * Communicate with lead API
 */
export default new LeadResponseService(new MrfiktivHttpClientProvider());
